/* istanbul ignore file */
import { Paragraph } from '@econsult/econsult-ui/dist/components/shared/typography';
import styled from 'styled-components';
import { Button } from '@econsult/econsult-ui/dist/components/Button';
import { commonButtonStyles } from './sharedStyles';

export const ButtonComponent = styled(Button)`
  ${commonButtonStyles}
  height: 32px;
  min-width: 82px;
`;

export const StyledButtonText = styled(Paragraph).attrs({ typography: 'ParagraphXsmallHeavy' })`
  padding: 0;
  margin: 0;
`;

export const ToggleButton = styled.button`
  ${commonButtonStyles}
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  font-size: 12px;
  color: ${({ theme }) => theme.colorPrimaryPrimary100};
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  width: auto;

  &:hover {
    text-decoration: underline;
    background: transparent;
  }
  &:focus {
    outline: none;
    box-shadow: none;
  }

  @media (max-width: 480px) {
    font-size: 14px;
    padding: 0.3rem;
  }
`;

export const StyledAiButton = styled(Button).attrs({ typography: 'ParagraphXsmallHeavy' })`
  width: 82px;
  height: 32px;
  border: 2px solid transparent;
  border-radius: 8px;
  padding: 8px 11px;
  color: ${({ theme }) => theme.colorPrimaryPrimary100} !important;
  background:
    linear-gradient(#E9E8ED, #E9E8ED) padding-box,
    linear-gradient(
      var(--angle, 0deg),
      #729DFF 4.23%,
      #78CCD5 38.35%,
      #FFAAD6 67.64%,
      #FFB64A 97.21%
    ) border-box;
  animation: rotate 8s linear infinite;
  transition: background 0.3s ease, color 0.3s ease;

  &:focus-visible {
    outline: 2px solid #3B82F6 !important;
    outline-offset: -2px !important;
  }

  outline: none !important;
  &:not(:disabled):hover {
    border: 2px solid transparent;
    border-radius: 8px;
    background:
      linear-gradient(#FFFFFF, #FFFFFF) padding-box,
      linear-gradient(
        var(--angle, 0deg),
        #729DFF 4.23%,
        #78CCD5 38.35%,
        #FFAAD6 67.64%,
        #FFB64A 97.21%
      ) border-box;
    color: ${({ theme }) => theme.colorPrimaryPrimary100} !important;
  }

  @property --angle {
    syntax: '<angle>';
    initial-value: 0deg;
    inherits: false;
  }

  @keyframes rotate {
    to {
      --angle: 360deg;
    }
  }
`;
